<template>  
<div> <!-- root element start -->
          <div class="row">
            <div class="col-12">
                <div class="card border-0">
                  <div class="card-header font-weight-bold bg-transparent border-0">
                    <i class="fa fa-plus-circle text-success" aria-hidden="true" @click="changeBottomView('item-product-create', '','',[])" ></i> 
                    Item Products <button v-if="orderChangeButton == '1'" class="btn btn-sm btn-primary float-right" @click="updateOrder">Save Order</button></div>

                  <div v-if="loading == 0" class="card-body">
                    <div class="col-12 mt-4">
                      <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
                    </div>
                  </div>
                    
                  <div v-if="loading == 1" class="card-body border-bottom" style="height:400px; overflow:auto">

                      <div v-for="(item,index) in itemList" class="row border p-1 mb-1">
                        <div class="col-2">
                          <i class="fa fa-ellipsis-v mr-2 handle" aria-hidden="true"></i>
                          <span class="mr-3">{{ item.id }}</span>
                        </div>
                        <div class="col-2 text-truncate">
                          {{ item.part_number }}
                        </div>
                        <div class="col-7 text-truncate">
                          {{ item.name }}
                        </div>
                        <div class="col-1">
                         
                          <a href="#" @click="deleteInclude(item.pivot.id)" class="text-danger"><i class="fa fa-trash-o mr-3" aria-hidden="true"></i></a>
                        </div>
                      </div> 

                  </div>
                </div>
            </div>
            
          </div>

          <div class="row">
            <transition name="slide-fade" mode="out-in">
                <component 
                  :is="bottomView" 
                  :prop1="bvProp1" 
                  :prop2="bvProp2" 
                  :prop3="bvProp3" 
                  @onSComplete="successComplete" 
                  @onUComplete="unsuccessComplete"
                  @secondaryAction="secondaryAction"
                >
                </component>
              </transition>
          </div>

</div> <!-- root element end -->
</template>


<script>

import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/admin-item-single-main-store.js'

import productCreate from './itemProductComponents/item-product-create.vue'

export default {
  props: ['item'],
  store,
  data: function () {
    return { 
      bottomView: '',
      bvProp1: '',
      bvProp2: '',
      bvProp3: [],
      loading: '1',
      orderChangeButton: '0',
    }
  },
  computed: {
    detailsList () { return this.$store.state.detailsList },

    itemList () { return this.$store.state.itemProductList },
    itemComp () { return this.$store.state.itemProductComp },
    allItemList () { return this.$store.state.productList },
  },
  watch: {
    itemComp() {
      if(this.itemComp == 0) {
        this.loading = 0;
      } else {
        this.loading = 1;
      }
    }
  },
  mounted() {

  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },
    changeBottomView(name, prop1, prop2, prop3) { this.bottomView = name; this.bvProp1 = prop1; this.bvProp2 = prop2; this.bvProp3 = prop3; },
    getAllItemProducts() { this.$store.dispatch("getAllItemProducts", { prod: this.detailsList.id }) },

    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'create-item':
          
          _this.changeBottomView('', '', '', []);
          _this.getAllItemProducts();
        break;

        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'create-item':
          _this.changeBottomView('', '', '', []);
        break;

        default:
      }
    },
    secondaryAction(value) {
      var _this = this;
      switch(value[0]) {
        case 1:
        var setup = [value[2]];
          _this.changeBottomView(value[1], '', '', setup);
        break;
        
        default:
      }
    },

    deleteInclude(x) {
      var _this = this;
      _this.changeBottomView('', '', '', []);
      _this.$swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          axios.get('/admin/utility/product/item/deleterel/' + x)
          .then(function (response) {
          var msg = response.data.msg;
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.getAllItemProducts();
          })
        }
      })
    },

    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },
    
  },    
  components:{
    
    ScalingSquaresSpinner,
    'item-product-create' : productCreate,
    
  },
  filters: {

  }
}
</script>
